import React, { useState } from "react";
import { FilterButtonGroup } from "../filter-button-group";
import { Input } from "antd";
import filterStyles from "../filter.css";

export type TextFilterProps = {
  defaultValue?: string;
  onApplyFilter: (value: string) => void;
  onClearFilter: () => void;
};

const {
  ["filter-dropdown"]: filterDropdownClassName,
  ["filter-content"]: filterContentClassName,
  ["filter-input"]: filterInputClassName,
} = filterStyles;

export const TextFilter = ({ defaultValue, onApplyFilter, onClearFilter }: TextFilterProps) => {
  const [canApply, setCanApply] = useState(false);
  const [value, setValue] = useState(defaultValue || "");

  const onClickApply = () => {
    setCanApply(false);
    onApplyFilter && onApplyFilter(value);
  };

  const onClickClear = () => {
    setValue("");
    setCanApply(false);
    onClearFilter && onClearFilter();
  };

  const onChange = (newValue: string) => {
    setValue(newValue);
    setCanApply(true);
  };

  return (
    <div className={filterDropdownClassName}>
      <FilterButtonGroup
        canApply={canApply}
        canClear={value?.length > 0}
        onClickApply={onClickApply}
        onClickClear={onClickClear}
      />
      <div className={filterContentClassName}>
        <Input
          className={filterInputClassName}
          placeholder="Enter text to filter by"
          onChange={(e) => onChange(e.target.value)}
          value={value}
          bordered={false}
        />
      </div>
    </div>
  );
};
